import { useState } from "react";
import { Navigate } from "react-router-dom";
import { useSevenAccess, SevenShell } from "./DashboardSeven";
import { SCRIPTS, HOME_NIGHTS, MONTHLY, ACCESS } from "../../data/sevenNights";
import { Copy, Check, MessageCircle, MoonStar, CalendarDays } from "lucide-react";
import { FONT_DISPLAY } from "../../lib/sevenTheme";

const ScriptCard = ({ text, i, group, copied, onCopy }) => (
  <div className="bg-[#1C1010]/60 border border-[#C9A66A]/18 hover:border-[#C9A66A]/40 rounded-xl px-5 py-4 flex items-start gap-3" data-testid={`seven-script-${group}-${i}`}>
    <div className="text-[14px] text-[#F5EAD3] leading-[1.95] flex-1">{text}</div>
    <button onClick={() => onCopy(text, `${group}-${i}`)} className="shrink-0 text-[#C9A66A] hover:text-[#E7C98C] transition-colors">
      {copied === `${group}-${i}` ? <Check className="w-4 h-4" /> : <Copy className="w-4 h-4" />}
    </button>
  </div>
);

export const ScriptsSeven = () => {
  const { loading, bundle } = useSevenAccess();
  const [tab, setTab] = useState("wife");
  const [copied, setCopied] = useState(null);

  if (loading) return <div className="min-h-screen bg-[#0A0606] flex items-center justify-center text-[#A7956E]">جاري التحميل…</div>;
  if (!(ACCESS[bundle] || ACCESS.starter).scripts) return <Navigate to="/7days/dashboard" replace />;

  const copy = async (text, k) => {
    try { await navigator.clipboard.writeText(text); setCopied(k); setTimeout(() => setCopied(null), 1400); } catch (_) { /* clipboard blocked */ }
  };

  const tabs = [
    { key: "wife", label: "من الزوجة", icon: MessageCircle },
    { key: "husband", label: "من الزوج", icon: MessageCircle },
    { key: "neutral", label: "مشتركة", icon: MessageCircle },
  ];

  return (
    <SevenShell title="رسائل واتساب جاهزة" testid="seven-scripts-root">
      <p className="text-[14px] text-[#CFC3A1] leading-[1.95] mb-6 max-w-2xl">
        رسائل قصيرة محترمة جاهزة للنسخ. اضغطي أيقونة النسخ للحصول على نسخة فورية.
      </p>
      <div className="flex flex-wrap gap-2 mb-6" data-testid="seven-scripts-tabs">
        {tabs.map(({ key, label }) => (
          <button key={key} onClick={() => setTab(key)} data-testid={`seven-scripts-tab-${key}`} className={`text-[12.5px] font-bold tracking-wide px-5 py-2.5 rounded-full border transition-all ${tab === key ? "bg-[#C9A66A]/15 border-[#C9A66A]/55 text-[#E7C98C]" : "border-white/[0.10] text-[#CFC3A1] hover:border-[#C9A66A]/35"}`}>
            {label}
          </button>
        ))}
      </div>
      <div className="space-y-2.5">
        {(SCRIPTS[tab] || []).map((t, i) => <ScriptCard key={i} text={t} i={i} group={tab} copied={copied} onCopy={copy} />)}
      </div>
    </SevenShell>
  );
};

export const BonusSeven = () => {
  const { loading, bundle } = useSevenAccess();
  if (loading) return <div className="min-h-screen bg-[#0A0606] flex items-center justify-center text-[#A7956E]">جاري التحميل…</div>;
  if (!(ACCESS[bundle] || ACCESS.starter).bonus) return <Navigate to="/7days/dashboard" replace />;

  return (
    <SevenShell title="أفكار ليالي بيتية + خطة الاستمرار" testid="seven-bonus-root">
      <section className="mb-12">
        <div className="flex items-center gap-2 mb-4">
          <MoonStar className="w-4 h-4 text-[#C9A66A]" />
          <h2 className="text-[15px] font-bold text-white tracking-wide" style={{ fontFamily: FONT_DISPLAY }}>10 أفكار ليالي بيتية</h2>
        </div>
        <div className="grid sm:grid-cols-2 gap-3" data-testid="seven-bonus-nights">
          {HOME_NIGHTS.map((t, i) => (
            <div key={i} className="bg-[#1C1010]/60 border border-[#C9A66A]/20 rounded-xl px-5 py-4 flex items-center gap-3">
              <span className="text-[20px] font-extrabold text-[#C9A66A] tabular-nums leading-none" style={{ fontFamily: FONT_DISPLAY }}>{i + 1}</span>
              <span className="text-[14px] text-[#F5EAD3]">{t}</span>
            </div>
          ))}
        </div>
      </section>

      <section>
        <div className="flex items-center gap-2 mb-4">
          <CalendarDays className="w-4 h-4 text-[#C9A66A]" />
          <h2 className="text-[15px] font-bold text-white tracking-wide" style={{ fontFamily: FONT_DISPLAY }}>خطة الاستمرار الشهرية</h2>
        </div>
        <div className="grid sm:grid-cols-2 gap-3" data-testid="seven-bonus-monthly">
          {MONTHLY.map((w, i) => (
            <div key={i} className="bg-gradient-to-b from-[#2A1414] to-[#150C0C] border border-[#C9A66A]/30 rounded-xl px-5 py-4">
              <div className="text-[10px] tracking-[0.24em] text-[#C9A66A] font-bold mb-1.5">{w.week}</div>
              <div className="text-[14.5px] text-white font-bold">{w.focus}</div>
            </div>
          ))}
        </div>
      </section>
    </SevenShell>
  );
};
